import { Fragment } from "react";

export const renderMessage = (text, mailto) => {
  if (text?.includes("Email us")) {
    const parts = text.split("Email us");
    return parts.map((part, i) => (
      <Fragment key={i}>
        {part}
        {i !== parts.length - 1 && (
          <a
            href={`mailto:${mailto}?subject=WealthWorthy Eligibility Help`}
            className="underline underline-offset-2"
          >
            Email us
          </a>
        )}
      </Fragment>
    ));
  }

  // Return text if there's no link phrase
  return text;
};

